import EntityBase from '@/data/EntityBase';
import FreeTrial from '@/data/freetrial/model';

export default class FreeTrialState extends EntityBase({
  trialStatus: new FreeTrial(),
}) {}
